import { render, staticRenderFns } from "./dailyluckback.vue?vue&type=template&id=28c89f97&scoped=true"
import script from "./dailyluckback.vue?vue&type=script&lang=js"
export * from "./dailyluckback.vue?vue&type=script&lang=js"
import style0 from "./dailyluckback.vue?vue&type=style&index=0&id=28c89f97&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c89f97",
  null
  
)

export default component.exports